import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const careersBoxLinksBlockFields = `
  _id,
  _type,
  heading,
  decorativeShape,
  boxLinks[]{
    icon {
      ${imageFields}
    },
    heading,
    mainText,
    buttonLink {
      ${inlineCtaFields}
    }
  }
`

export const CAREERS_BOX_LINKS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-box-links-block"][0]{
    ${careersBoxLinksBlockFields}
  }
`)
